import Vue from 'vue';
import store from '@/store';
import $ from 'jquery'

import AddDirectoryElement from './AddDirectoryElementModal.vue';

export default function(){
    let element = $(`<div id="gnzs-1c-amo__add-directory-element-modal-container"></div>`)
    element.width(`700px`)
    $('body').append(element)

    new Vue({
        store,
        render: h => h(AddDirectoryElement)
    }).$mount('#gnzs-1c-amo__add-directory-element-modal-container');
}